import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}
import { computed, inject, onMounted, ref, watch, type SetupContext } from "vue";
import { BPagination } from "bootstrap-vue-next";
import { CourseSearchCommand } from "../../application/command/CourseSearchCommand.ts";
import type { CourseDto } from "../../shared/CourseDto.ts";
import type { CourseService } from "../../application/services/CourseService.ts";

interface Props {
  categoryId: number;
  search: string;
}

export default {
  template: html,
  components: {
    BPagination,
  },
  emits: {
      onBookCourseId: (value: number) => typeof value === "number"
  },
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    search: {
      type: String,
      required: false,
    },
  },
  setup(props: Props, {emit}:SetupContext) {
    const courses = ref<CourseDto[]>([]);
    const error = ref<string>("");
    const page = ref<number>(1);
    const perPage = ref<number>(10);
    const totalPages = ref<number>(1);
    const sortBy = ref<string>("");
    const sortDir = ref<string>("ASC");

    const courseService: CourseService | undefined = inject("courseService");

    // computed properties and watchers
    const courseCategoryId = computed(() => {
      return props.categoryId > 0 ? props.categoryId : null
    })
    watch(courseCategoryId, async () => {
      if (page.value == 1) {
        await loadCourses();
      } else {
        page.value = 1; // this will trigger load
      }
    });

    const search = computed(() => {
      return props.search
    })
    watch(search, async () => {
      if (page.value == 1) {
        await loadCourses();
      } else {
        page.value = 1; // this will trigger load
      }
    });

    // methods
    const toLocaleDateString = function (dateStr: string) {
      const date = new Date(dateStr);
      return date.toLocaleDateString();
    };

    const setSortBy = async (col: string) => {
      if (sortBy.value == col) {
        sortDir.value = sortDir.value == "ASC" ? "DESC" : "ASC";
      }
      page.value = 1;
      await loadCourses();
    };

    const onBookCourse = function (courseId: number) {
      emit("onBookCourseId", courseId)
    };

    const loadCourses = async function () {
      
      const cmd = new CourseSearchCommand(
        courseCategoryId.value,
        search.value,
        page.value,
        perPage.value,
        sortBy.value,
        sortDir.value == "DESC",
      );
      if (courseService) {
        try {
          const res = await courseService.search(cmd);
          courses.value = res.results;
          totalPages.value = res.meta.totalPages;
        } catch (err) {
          error.value = String(err);
        }
      }
    };
    
    watch(page, async () => {
      await loadCourses();
    });
    
    onMounted(async () => {
      await loadCourses();
    });
    
    return {
      error,
      courses,
      onBookCourse,
      search,
      page,
      perPage,
      totalPages,
      sortBy,
      sortDir,
      setSortBy,
      toLocaleDateString,
    };
  },
};
